<ol>
  @for (link of $links(); track $index) {
    <li aria-disabled (click)="scrollTo(link.id)">
      <a
        [class]="[$index === $scrollIndex() ? 'filled' : '']"
        [title]="link.title"
        >{{ link.title }}</a
      >
    </li>
  }
</ol>
